import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f6aac71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-action float-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-edit me-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-newspaper me-2" }),
  /*#__PURE__*/_createTextVNode("ข้อมูลรายละเอียด")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "ข้อมูลรายละเอียดข่าวประชาสัมพันธ์ของ ส.กกภ.", -1))
const _hoisted_7 = { class: "card-body my-3" }
const _hoisted_8 = { class: "text-center mb-4" }
const _hoisted_9 = { class: "fas fa-star text-warning" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-action float-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-image me-2" }),
  /*#__PURE__*/_createTextVNode("รูปภาพประกอบ")
], -1))
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "list-group" }
const _hoisted_19 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "list-group-item p-2"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "card" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "card-action float-end" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารแนบ")
], -1))
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "list-group" }
const _hoisted_32 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_34 = ["href", "download"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnouncementFormComponent = _resolveComponent("AnnouncementFormComponent")!
  const _component_AnnouncementImageComponent = _resolveComponent("AnnouncementImageComponent")!
  const _component_AnnouncementDocumentComponent = _resolveComponent("AnnouncementDocumentComponent")!
  const _component_AnnouncementUploadComponent = _resolveComponent("AnnouncementUploadComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
          }, [
            _hoisted_4,
            _createTextVNode("แก้ไข ")
          ])
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h4", null, [
            _withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [
              [_vShow, _ctx.announcement?.pined]
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.announcement?.title), 1)
          ])
        ]),
        _withDirectives(_createElementVNode("div", null, null, 512), [
          [_directive_dompurify_html, _ctx.announcement?.content.replace(/(?:\r\n|\r|\n)/g, '<br />')]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.imageClick && _ctx.imageClick(...args)))
              }, [
                _hoisted_15,
                _createTextVNode("จัดการ ")
              ])
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              (_ctx.images?.length === 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode("ไม่มีข้อมูล ")
                  ]))
                : (_openBlock(), _createElementBlock("li", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: index,
                        href: image.file,
                        "data-lightbox": "announcement-images"
                      }, [
                        _createElementVNode("img", {
                          src: image.file,
                          class: "image-content",
                          alt: `image-${index}`
                        }, null, 8, _hoisted_23)
                      ], 8, _hoisted_22))
                    }), 128))
                  ]))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.documentClick && _ctx.documentClick(...args)))
              }, [
                _hoisted_28,
                _createTextVNode("จัดการ ")
              ])
            ]),
            _hoisted_29
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("ul", _hoisted_31, [
              (_ctx.documents?.length === 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                    _hoisted_33,
                    _createTextVNode("ไม่มีข้อมูล ")
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.documents, (document, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "list-group-item text-truncate"
                    }, [
                      _createElementVNode("a", {
                        href: document.file,
                        download: document.name,
                        target: "_blank"
                      }, [
                        _hoisted_35,
                        _createTextVNode(_toDisplayString(document.name), 1)
                      ], 8, _hoisted_34)
                    ]))
                  }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AnnouncementFormComponent, {
      ref: "announcementForm",
      "announcement-id": _ctx.announcement?.id,
      onDeleted: _ctx.redirect
    }, null, 8, ["announcement-id", "onDeleted"]),
    _createVNode(_component_AnnouncementImageComponent, {
      ref: "announcementImage",
      "announcement-id": _ctx.announcement?.id
    }, null, 8, ["announcement-id"]),
    _createVNode(_component_AnnouncementDocumentComponent, {
      ref: "announcementDocument",
      "announcement-id": _ctx.announcement?.id,
      onUpload: _ctx.handleUpload
    }, null, 8, ["announcement-id", "onUpload"]),
    _createVNode(_component_AnnouncementUploadComponent, {
      ref: "announcementUpload",
      "announcement-id": _ctx.announcement?.id,
      onHidden: _ctx.handleHidden
    }, null, 8, ["announcement-id", "onHidden"])
  ], 64))
}